export default "<p>\n  mock works!\n</p>\n"